import { render, staticRenderFns } from "./NewRateCard.vue?vue&type=template&id=74664605&scoped=true&lang=html&"
import script from "./NewRateCard.vue?vue&type=script&lang=js&"
export * from "./NewRateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74664605",
  null
  
)

export default component.exports